/**
 * Adapts language sources by translating their labels using the provided translation function.
 *
 * @param langSources - Array of language source objects containing at least a label key.
 * @param t - The i18next translation function.
 * @returns An array of adapted language objects with translated labels.
 */
export interface LangSource {
    label: string;
    [key: string]: any;
}

export const languagesAdapt = (
    langSources: LangSource[] = [],
    t: (key: string) => string,
): LangSource[] => {
    if (!Array.isArray(langSources)) {
        console.warn('langSources should be array');

        return [];
    }

    if (typeof t !== 'function') {
        console.warn('t should be function');

        return [];
    }

    return langSources.map((langSource) => ({
        ...langSource,
        label: t(langSource.label),
    }));
};
